import { render } from "./mainProgram.vue?vue&type=template&id=57d93c90"
import script from "./mainProgram.vue?vue&type=script&lang=js"
export * from "./mainProgram.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./mainProgram.vue?vue&type=style&index=0&id=57d93c90&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__